"use strict";
/*
    Map common data to redux store structure
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.sportsToStore = sportsToStore;
exports.outcomeCategoriesToStore = outcomeCategoriesToStore;
exports.marketsToStore = marketsToStore;
exports.currenciesToStore = currenciesToStore;
exports.marketCategoriesToStore = marketCategoriesToStore;
exports.marketGroupsToStore = marketGroupsToStore;
exports.systemCurrenciesToStore = systemCurrenciesToStore;
exports.matchPhasesToStore = matchPhasesToStore;
exports.hotProbabilitiesGroupsToStore = hotProbabilitiesGroupsToStore;
exports.entityTagsToStore = entityTagsToStore;
exports.virtualCategoriesToStore = virtualCategoriesToStore;
exports.virtualCategoriesToStoreV2 = virtualCategoriesToStoreV2;
const _reduxjs_1 = require("../../../utils/@reduxjs");
const outcomes_1 = require("../../../utils/outcomes");
const utils_1 = require("../utils");
function sportsToStore(sports) {
    if (sports === undefined || sports.length === 0) {
        return {
            sports: {},
            sportsIdsOrder: [],
            sportIdsByGenericSportId: {},
        };
    }
    const result = {
        sports: {},
        sportsIdsOrder: [],
        sportIdsByGenericSportId: {},
    };
    for (let i = 0; i < sports.length; i += 1) {
        const sport = sports[i];
        result.sports[sport.id] = sport;
        result.sportsIdsOrder.push(sport.id);
        if (sport.genericSportId !== undefined && sport.genericSportId !== null) {
            if (result.sportIdsByGenericSportId[sport.genericSportId] === undefined) {
                result.sportIdsByGenericSportId[sport.genericSportId] = [];
            }
            result.sportIdsByGenericSportId[sport.genericSportId].push(sport.id);
        }
    }
    return result;
}
function outcomeCategoriesToStore(outcomeCategories) {
    if (outcomeCategories === undefined) {
        return {
            outcomeCategories: {},
        };
    }
    else {
        return {
            outcomeCategories: (0, _reduxjs_1.toIdsMap)(outcomeCategories),
        };
    }
}
function marketsToStore(markets) {
    if (markets === undefined) {
        return {
            markets: {},
            outcomeTypes: {},
            mainOutcomeTypes: {},
        };
    }
    else {
        const res = {
            markets: {},
            outcomeTypes: {},
            mainOutcomeTypes: {},
        };
        for (const market of markets) {
            res.markets[market.id] = market;
            for (const outcomeType of market.orderedOutcomeTypes) {
                res.outcomeTypes[outcomeType.id] = outcomeType;
            }
        }
        res.mainOutcomeTypes = (0, utils_1.collectMainOutcomes)(markets);
        return res;
    }
}
function currenciesToStore(currencies) {
    return {
        currencies: (0, _reduxjs_1.toIdsMap)(currencies !== null && currencies !== void 0 ? currencies : []),
    };
}
function marketCategoriesToStore(marketCategories) {
    if (marketCategories === undefined) {
        return {
            marketCategories: {
                entries: {},
                sortedIds: [],
            },
            categoryMarketInfosMap: {},
        };
    }
    else {
        return {
            marketCategories: {
                entries: (0, utils_1.computeMarketCategoriesEntries)((0, _reduxjs_1.toIdsMap)(marketCategories)),
                sortedIds: (0, _reduxjs_1.toIdsArray)(marketCategories),
            },
            categoryMarketInfosMap: (0, utils_1.computeCategoryMarketInfosMap)(marketCategories),
        };
    }
}
function marketGroupsToStore(marketGroups) {
    if (marketGroups === undefined) {
        return {
            marketGroups: {
                entries: {},
                sortedIds: [],
            },
        };
    }
    const result = {
        marketGroups: {
            entries: {},
            sortedIds: [],
        },
    };
    marketGroups.forEach((marketGroup) => {
        result.marketGroups.entries[marketGroup.id] = marketGroup;
        result.marketGroups.sortedIds.push(marketGroup.id);
    });
    return result;
}
function systemCurrenciesToStore(systemCurrencies) {
    return {
        systemCurrencies: (0, utils_1.formatSystemCurrencies)(systemCurrencies !== null && systemCurrencies !== void 0 ? systemCurrencies : []),
    };
}
function matchPhasesToStore(matchPhases) {
    return {
        matchPhases: (0, _reduxjs_1.toIdsMap)(matchPhases !== null && matchPhases !== void 0 ? matchPhases : []),
    };
}
function hotProbabilitiesGroupsToStore(hotProbabilitiesGroups) {
    if (hotProbabilitiesGroups === undefined) {
        return {
            hotProbabilitiesGroups: {},
        };
    }
    const temp = {};
    hotProbabilitiesGroups.forEach((group) => {
        temp[group.id] = {
            ...group,
            sports: group.sports.reduce((acc, sport) => {
                acc[sport.sportId] = sport;
                return acc;
            }, {}),
        };
    });
    return {
        hotProbabilitiesGroups: temp,
    };
}
function entityTagsToStore(entityTags) {
    return { entityTags: (0, _reduxjs_1.toIdsMap)(entityTags !== null && entityTags !== void 0 ? entityTags : []) };
}
function virtualCategoriesToStore(virtualCategories) {
    if (virtualCategories === undefined) {
        return {
            virtualCategories: {
                entries: {},
                sortedIds: [],
            },
            virtualMarketInfosMap: {},
        };
    }
    return {
        virtualCategories: {
            entries: (0, utils_1.computeVirtualCategoriesEntries)((0, _reduxjs_1.toIdsMap)(virtualCategories)),
            sortedIds: (0, _reduxjs_1.toIdsArray)(virtualCategories),
        },
        virtualMarketInfosMap: (0, utils_1.computeVirtualMarketInfosMap)(virtualCategories),
    };
}
function virtualCategoriesToStoreV2(virtualCategories) {
    var _a, _b;
    if (virtualCategories === undefined) {
        return {
            vCategoriesInfo: {
                entries: {},
                sortedIds: [],
            },
            vMarketsInfo: {},
            vMarketIdsByMarket: {},
        };
    }
    const result = {
        vCategoriesInfo: {
            entries: {},
            sortedIds: [],
        },
        vMarketsInfo: {},
        vMarketIdsByMarket: {},
    };
    for (const vCategory of virtualCategories) {
        result.vCategoriesInfo.sortedIds.push(vCategory.id);
        result.vCategoriesInfo.entries[vCategory.id] = {
            id: vCategory.id,
            name: vCategory.name,
            sportIds: new Set(vCategory.sportIds),
            orderedVirtualMarketIds: (0, _reduxjs_1.toIdsArray)(vCategory.orderedVirtualMarkets),
        };
        for (const vMarket of vCategory.orderedVirtualMarkets) {
            result.vMarketsInfo[vMarket.id] = {
                ...vMarket,
                vCategoryId: vCategory.id,
                shouldCustomizeGroupName: (0, outcomes_1.shouldCustomizeName)(vMarket.outcomesGroup.name),
                shouldCustomizeOutcomeName: (_b = (_a = vMarket.outcomeCustomizations) === null || _a === void 0 ? void 0 : _a.some((el) => (0, outcomes_1.shouldCustomizeName)(el.name || el.shortName))) !== null && _b !== void 0 ? _b : false,
            };
            if (result.vMarketIdsByMarket[vMarket.filteredBy.marketId] === undefined) {
                result.vMarketIdsByMarket[vMarket.filteredBy.marketId] = [];
            }
            result.vMarketIdsByMarket[vMarket.filteredBy.marketId].push(vMarket.id);
        }
    }
    return result;
}
//# sourceMappingURL=toStore.js.map